var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F6931E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2499 15.0264C32.2499 15.0264 32.0061 13.3106 31.2566 12.5552C30.3056 11.565 29.2404 11.5592 28.752 11.503C25.2532 11.25 20.0055 11.25 20.0055 11.25H19.9937C19.9937 11.25 14.746 11.25 11.248 11.503C10.7596 11.5592 9.69522 11.565 8.74336 12.5552C7.99469 13.3106 7.75008 15.0264 7.75008 15.0264C7.75008 15.0264 7.5 17.0396 7.5 19.0528V20.9399C7.5 22.9546 7.75008 24.9671 7.75008 24.9671C7.75008 24.9671 7.9939 26.6821 8.74336 27.436C9.69522 28.4263 10.9433 28.3964 11.4997 28.4999C13.4995 28.6909 20 28.75 20 28.75C20 28.75 25.2532 28.7413 28.752 28.4911C29.2404 28.4328 30.3056 28.427 31.2566 27.4368C32.0053 26.6828 32.2499 24.9678 32.2499 24.9678C32.2499 24.9678 32.5 22.9546 32.5 20.9406V19.0535C32.5 17.0396 32.2499 15.0264 32.2499 15.0264Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0898 15V25L25.4232 20L17.0898 15Z",
    fill: "#F6931E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtubeIcon.4b97f2055797aeadf18958b26bce9414.svg";
export { ForwardRef as ReactComponent };